var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 367 117",
    width: 367,
    height: 117,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#440086}.c{fill:#ce0085}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m308.5 0.2h-250c-32.1 0-58.2 26.1-58.2 58.2 0 32.2 26.1 58.3 58.2 58.3h250c32.2 0 58.3-26.1 58.3-58.3 0-32.1-26.1-58.2-58.3-58.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m97.1 58.4c0 4.4-0.7 8.6-2 12.6q-0.4 1.5-1.1 3-0.2 0.6-0.4 1.1-0.2 0.5-0.5 1c-3 6.5-7.6 12-13.3 16.2q-0.9 0.6-1.8 1.2c-4.3 2.7-9.1 4.7-14.3 5.8q-0.8 0.1-1.6 0.3-3.3 0.5-6.7 0.5-0.6 0-1.2 0c-5.3-0.1-10.4-1.3-15-3.2q0-0.1 0-0.1-1.6-0.6-3.2-1.5c-13.2-6.9-22.3-20.9-22.3-36.9 0-23 18.7-41.6 41.7-41.6 23 0 41.7 18.6 41.7 41.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m94 74c-0.3 0.5-0.5 0.9-0.4 1.1q-0.2 0.5-0.5 1c-3 6.5-7.6 12-13.3 16.2-3.2 0-6.1-1.1-9.5-3.3-3.5-2.2-8.1-6.6-10.7-10.5-1.7 0.4-3.7 0.7-4.9 0.6l7.4 20.5q-3.3 0.5-6.7 0.5-0.6 0-1.2 0c-5.3-0.1-10.4-1.3-15-3.2l-19.3-56.6 26.9-8.9c16.6-5.5 29.8-0.2 34.6 14.3 2.8 8.6 0.7 16.6-4.3 22.5 2.2 2.3 5 4.4 7.1 5.3q0 0 0 0.1c2.6 1.2 5.7 0.8 8.1-0.7l2.8-1.9q-0.4 1.5-1.1 3zm-33.8-21.2c-2-5.9-6.6-7.7-12.7-5.7l-3.1 1 5.7 17.3c1-0.1 2.3-0.4 3.5-0.8 5.6-1.8 8.5-6 6.6-11.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m237.6 60.5c0 19.8-15 31.1-31.5 31.1-16.4 0-31.4-11.3-31.4-31.1 0-19.8 15-31.1 31.4-31.1 16.5 0 31.5 11.3 31.5 31.1zm-20.5 0.5c0-10-4.4-16-11.4-16-6.4 0-10.5 5-10.5 14.9 0 10.1 4.4 16.1 11.4 16.1 6.3 0 10.5-5 10.5-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m244.5 31.6c4-1 8.7-1.6 15.1-1.6 3.5 0 5.4 1.5 5.4 4.4v4.4c3.1-5.4 8.8-9.4 16.3-9.4 6.3 0 10.9 2.7 10.9 6.1 0 4.3-4.1 8.8-8.7 11.6-2.1-1.5-4.9-2.1-7.3-2.1-5.8 0-9.8 4.1-11.2 10.9v34.3h-16.2c-2.9 0-4.3-1.2-4.3-3.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m297.6 15.3c0-6.2 4.6-9.4 10.8-9.4 5.7 0 11 3.5 11 9.7 0 6.1-4.5 9.4-10.8 9.4-5.6 0-11-3.5-11-9.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m116 88.8c-2.2 0-3.2-1-3.2-2.6v-56.8h30.1c15.4 0 24.9 8.1 24.9 21.5 0 7.9-4 14-9.8 17.5 1.2 2.5 3 5 4.5 6.4 1.6 1.5 3.3 2.1 5.3 2.1h1.5c0.7 1.8 1.1 3.8 1.1 6.3 0 3-8.9 6.6-14.4 6.6-4.9 0-8.1-1.8-11.5-5.9-2.3-2.8-4.9-7.8-6-11.7-1.4-0.2-3.2-0.5-4.2-0.9v17.5zm18.2-30.2c0.9 0.2 2.1 0.3 3.2 0.3 5.1 0 8.7-2.6 8.7-8 0-5.5-3.4-8.3-9-8.3h-2.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m313.3 30c-6.3 0-11 0.6-15 1.6v55.2c0 2.2 1.3 3.4 4.2 3.4h16.3v-55.8c0-2.9-1.9-4.4-5.5-4.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.0d2c75f1851fd80aacdc99452d08cf2f.svg";
export { ForwardRef as ReactComponent };